// extracted by css-extract-rspack-plugin
export default {"group":"group-D8rMcd","label":"label-mLYqys","selected":"selected-G7bj3g"};